import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../web/components/Button';
import { SparklesIcon } from '../../../web/components/svgs/icons/SparklesIcon';
import { baseStyleSheet } from '../../../web/styles/styles';
import { MrryDirection, MrryMessageType, MrryModal } from '../MrryModal';
import { styleSheet } from './styles';

interface IMrryPostCallMessageProps {
	isLoading: boolean;
	onGetAISummary: () => void;
	onClose: () => void;
}

export const MrryPostCallMessage: React.FC<IMrryPostCallMessageProps> = ({ isLoading, onGetAISummary, onClose }) => {
	const messageContent = (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.text)}>Would you like some feedback on your call?</div>
			<Button
				kind='secondary'
				size='small'
				onClick={onGetAISummary}
				disabled={isLoading}
				className={css(styleSheet.button)}
			>
				<span className={css(styleSheet.buttonText, baseStyleSheet.truncateText)}>
					<SparklesIcon className={css(styleSheet.sparkleIcon)} />
					{isLoading ? 'Generating...' : 'AI Call Coach'}
				</span>
			</Button>
		</div>
	);

	return (
		<MrryModal
			fromDirection={MrryDirection.FromTop}
			message={{
				content: messageContent,
				duration: 0, // null means no duration
				type: MrryMessageType.Success,
			}}
			onRequestClose={onClose}
			internalCloseButton={false}
		/>
	);
};
